import { SoundSceneObject, State } from '@cgs/wge';

export class SoundInstance {
  public static readonly Empty: SoundInstance = new SoundInstance(null, null);

  private readonly _sound: SoundSceneObject | null;
  private readonly _stateMachine: State | null;

  constructor(sound: SoundSceneObject | null, stateMachine: State | null = null) {
    this._sound = sound;
    this._stateMachine = stateMachine;
  }

  public play(): void {
    this._sound?.play();
  }

  public stop(): void {
    this._sound?.stop();
  }

  public GoToState(state: string): void {
    this._stateMachine?.switchToState(state);
  }
}
